import styled from '@emotion/styled';
import { InquiryStatus } from '@models/inquiry';
import { useTranslation } from 'react-i18next';

interface Props {
    status: InquiryStatus;
}

function InquiryBadge({ status }:Props) {
    const { t } = useTranslation('inquiry');
    return (
        <Base className={status.toLowerCase()}>
            {t(`status.${status}`)}
        </Base>
    );
}

const Base = styled.span`
    border: 1px solid;
    border-radius: 15px;
    font-size: 12px;
    font-weight: bold;
    line-height: 1.4;
    padding: 2px 8px;
    
    &.pending, &.follow_up, &.on_hold {
        background-color: var(--color-secondary);
        border-color: var(--color-primary);
        color: var(--color-button-text);
    }
    
    &.answered {
        background-color: var(--color-surface-secondary);
        border-color: var(--color-gray6);
        color: var(--color-gray9);
    }
    
    &.closed {
        background-color: var(--color-gray6);
        border-color: #262320;
        color: var(--color-white);
    }
`;

export default InquiryBadge;
